import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, theme, Button, message, Input, Modal } from "antd";
import { ProfileOutlined, PlusOutlined } from "@ant-design/icons";
import LoadingOverlay from "react-loading-overlay-ts";

import TopBar from "../../components/TopBar";
import SideBar from "../../components/SideBar";
import { FuneralProductTable } from "../../components/Table";
import {
  AddFuneralProductModal,
  EditFuneralProductModal,
} from "../../components/ModalForm";

import { AuthContext } from "../../context/AuthContext";

import "../../styles/Groups.css";
import {
  getCompanyFuneralProductsApi,
  addFuneralProductApi,
  editFuneralProductApi
} from "../../services/Funeral/FuneralProductApis";

const { Content } = Layout;
const { Search } = Input;

const FuneralProductPage: React.FC = () => {
  const [products, setProducts] = useState<any>([]);
  const [product, setProduct] = useState<any>({});
  const [filtered, setFiltered] = useState<any>([]);
  const [searchValue, setSearchValue] = useState<string>(
    () => sessionStorage.getItem("funeralProductsSearch") || ""
  );
  const [show, setShow] = useState(false);
  const [update, setUpdate] = useState(false);
  const [isActive, setActive] = useState(true);
  const [confirmDelete, setConfirmDelete] = useState(false); // State for confirmation modal
  const [groupToDelete, setGroupToDelete] = useState<string>(""); // State for confirmation modal
  const [key, setKey] = useState<string>(""); // State for confirmation modal

  const { currentUser, currentGroup } = useContext(AuthContext);

  const navigate = useNavigate();

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const showModal = () => {
    setShow(!show);
    setUpdate(false);
  };

  const showEditModal = (data: any) => {
    setProduct(data);
    setShow(!show);
    setUpdate(true);
  };

  const handleAdd = async (data: any) => {
    setActive(true);

    return await addFuneralProductApi(data, currentGroup)
      .then((res) => {
        setProducts([...products, res.data]);
        setActive(false);
        return res;
      })
      .catch((err) => {
        setActive(false);
        console.log(err);
      });
  };

  const handleUpdate = async (id: string, data: any) => {
    setActive(true);
    return await editFuneralProductApi(id, data)
      .then((res) => {
        const updatedProducts = products.map((product: any) => {
          if (id === product.id) {
            return { ...product, ...res.data };
          }
          return product;
        });
        setProducts(updatedProducts);
        setActive(false);
        return res;
      })
      .catch((err) => {
        setActive(false);
        console.log(err);
      });
  };

  const handleDelete = (id: string, key: string) => {
    setKey(key);
    setConfirmDelete(true);
    setGroupToDelete(id);
  };

  const onSearch = (e: any) => {
    const value = e.target.value;
    setSearchValue(value);
    if (value) sessionStorage.setItem("funeralProductsSearch", value);
    else sessionStorage.removeItem("funeralProductsSearch");
    if (value !== "") {
      const filteredData = products.filter((row: any) => {
        return Object.values(row)
          .join(" ")
          .toLowerCase()
          .includes(value.toLowerCase());
      });
      setFiltered(filteredData);
    }
  };

  const onCancelDelete = () => {
    setConfirmDelete(false);
    setGroupToDelete("");
  };

  const onConfirmDelete = () => {
    // setConfirmDelete(false);
    // setActive(true);
    // removeGroupApi(groupToDelete)
    //   .then((res) => {
    //     getGroupApi(String(currentGroup))
    //       .then((res) => {
    //         getLinkedGroupsApi(res.data.GroupLinkID, res.data.GroupLevel)
    //           .then((res) => {
    //             setActive(false);
    //             setGroups(res.data);
    //           })
    //           .catch((err) => {
    //             setActive(false);
    //             console.log(err);
    //           });
    //       })
    //       .catch((err) => {
    //         setActive(false);
    //         console.log(err);
    //       });
    //   })
    //   .catch((err) => {
    //     setActive(false);
    //     message.error(err);
    //     console.log(err);
    //   });
  };

  useEffect(() => {
    getCompanyFuneralProductsApi(String(currentGroup))
      .then((res) => {
        setProducts(res.data);
        setActive(false);
      })

      .catch((err) => {
        console.log(err);
      });
  }, [currentGroup]);

  return (
    <LoadingOverlay active={isActive} spinner>
      <Layout style={{ minHeight: "100vh" }}>
        <SideBar />
        <Layout className="site-layout">
          <TopBar />
          <Content>
            <div
              style={{
                padding: 24,
                minHeight: "100%",
                background: colorBgContainer,
              }}
            >
              <h2>
                <ProfileOutlined
                  style={{ paddingRight: "5px", color: "#f04f05" }}
                />
                Products
              </h2>
              <div className="interactions">
                <Button onClick={showModal} size="large">
                  <PlusOutlined style={{ paddingRight: "5px" }} />
                  Add Product
                </Button>

                <div>
                  <Search
                    placeholder="Search"
                    size="large"
                    value={searchValue}
                    onChange={(e) => onSearch(e)}
                    style={{ width: "100%", margin: "24px 0" }}
                  />
                </div>

                {update ? (
                  <EditFuneralProductModal
                    show={show}
                    product={product}
                    showModal={showModal}
                    handleUpdate={handleUpdate}
                  />
                ) : (
                  <AddFuneralProductModal
                    show={show}
                    showModal={showModal}
                    handleAdd={handleAdd}
                  />
                )}
              </div>

              <FuneralProductTable
                products={products}
                filtered={filtered}
                showEditModal={showEditModal}
                handleDelete={handleDelete}
              />
            </div>
          </Content>
        </Layout>
      </Layout>

      {/* Confirmation Modal */}
      {key === "1" ? (
        <Modal
          title="Confirm Remove"
          open={confirmDelete}
          onOk={onConfirmDelete}
          onCancel={onCancelDelete}
        >
          Are you sure you want to move this Product inactive?
        </Modal>
      ) : (
        <Modal
          title="Confirm Revert"
          open={confirmDelete}
          onOk={onConfirmDelete}
          onCancel={onCancelDelete}
        >
          Are you sure you want to move this Product active?
        </Modal>
      )}
    </LoadingOverlay>
  );
};

export default FuneralProductPage;
